import { PopoverTextWrapper } from '@components/tooltip/component/popover-text-wrapper';
import { Tooltip } from '@components/tooltip/tooltip';

import type { ActionItemLockedButtonProps } from './action-item-locked-button.type';
import { ACTION_ITEM_BUTTON_CLASSES, ACTION_ITEM_BUTTON_DISABLED_CLASSES } from './config';

// A disabled button fires no click, so this one only looks disabled.
export const ActionItemLockedButton = ({
  text,
  reason,
  Icon,
  dataTestId,
  anchorProps = { to: 'top', gap: 8 },
  activateWithHover = false,
}: ActionItemLockedButtonProps) => (
  <Tooltip
    ariaLabel={`${text}. ${reason}`}
    buttonTestId={dataTestId}
    popoverClasses='relative w-full'
    buttonClasses={`${ACTION_ITEM_BUTTON_CLASSES} ${ACTION_ITEM_BUTTON_DISABLED_CLASSES} cursor-not-allowed`}
    anchorProps={anchorProps}
    activateWithHover={activateWithHover}
    button={
      <>
        {Icon && <Icon className='w-6 h-6 text-center' />}
        {text}
      </>
    }
    popoverContent={<PopoverTextWrapper>{reason}</PopoverTextWrapper>}
  />
);
